module.exports = __webpack_public_path__ + "static/media/7.374cb4ff.gif";